// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprReject extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.reject";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprReject {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Nægte",
                "de": "Ablehnen",
                "en": "Refuse",
                "es": "Rechazar",
                "fr": "Refuser",
                "it": "Rifiutare",
                "nl": "Afwijzen",
                "pt": "Rejeitar",
                "ru": "Отклонить",
                "pt-BR": "Recusar",
                "ca": "Rebutjar",
                "eu": "Ukatu",
                "gl": "Denegar",
                "fi": "Estä",
                "hi": "इनकार",
                "hu": "Elutasítani",
                "no": "Avvis",
                "pl": "Odmówić",
                "ro": "Respinge",
                "cs": "Odmítnout",
                "sk": "Odmietnuť",
                "sv": "Neka"
            }
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
